import { API_URL } from '../../config';
import { getLoginToken } from '../../helpers/sessionHandler';
import { toast } from 'react-toastify';
import axios from 'axios';

export const GET_RODO = 'GET_RODO'

export const GetRodo = (rodo) => ({
  type: GET_RODO,
  rodo: rodo
})

export const FetchRodo = () => async (dispatch) => {
  var config = {
    headers: {'Authorization': "Bearer " + getLoginToken()},
  };

  axios.get(API_URL+`/rodo`, config)
    .then(res => {
        const { name, company } = res.data
        dispatch(GetRodo({ name, company }));
    })
}

export const ConfirmRodo = () => async () => {
  var data = { confirm: true }

  var config = {
    headers: {'Authorization': "Bearer " + getLoginToken()},
  };

  axios.post(API_URL+`/rodo`, data, config)
  .then(res => {
    toast.success("Potwierdzenie zapisane pomyślnie!");
  })
}





// WEBPACK FOOTER //
// ./src/store/rodo/actions.js